import { v4 as uuid } from "uuid";
import React, { Component } from "react";
import store from "@/redux/store";

import { createPortal } from 'react-dom';
import { Link, useNavigate, useLocation } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'
import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Edit as CustomerCompany } from "@/views/base/company/Edit";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import {showSettingsStorageBasemapSelect, hideModal} from "@/reducers/ModalPopup";
import {disconnectDropboxAccount} from "@/reducers/Tenant";

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'


export function Sectors({...props}) {
 const [open, setOpen] = useState(false)
    const defaultOption = {"key": "BASE", "name": "Basis sectoren"};
 const [selected, setSelected] = useState((props.data?.SECTORS?.copyFrom) ? props.data.SECTORS.copyFrom : defaultOption);
       
const setSector=(data) => {
    if(props.setFormValues) {
        props.setFormValues('tenant.fields.'+props?.registerkey+".copyFrom", data,  {
            shouldDirty: true,
            shouldTouch: true,
          });
    }
    setSelected(data);
}
/*
  React.useEffect(() => {
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["key"] && formState.defaultValues["key"] != "") {
            for (const [key, value] of Object.entries(formState.defaultValues)) {
                formState.defaultValues[key] = "";
            }          
            reset(formState.defaultValues, { keepDirtyValues: true }); 
      }
  }, [formState, reset])
*/
  return (
    <>
        <h1>Sectoren selecteren </h1>

    <Listbox onChange={setSector}>
      <Label className="block text-sm font-medium leading-6 text-gray-900">Sectoren</Label>
      <div className="relative mt-2">
       <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
            {selected && <span className="block truncate"><span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{selected['name']}</span></span>}       
          {!selected && <span className="block truncate text-gray-400">Selecteer</span>}
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
          </span>
        </ListboxButton>      

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >

            <Listbox.Option
              key={"BASE"}
              value={defaultOption}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
              data-active={selected?.key == "BASE" || !selected}
            >
              <span className="block truncate font-normal group-data-[active=true]:font-semibold">Basis sectoren</span>
            
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-active=true])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>

        
          {props?.tenants.map((tenant) => {
              if(tenant.key != props?.selectedTenant?.tenant?.key) { 
              return (<Listbox.Option
              key={tenant.key}
              value={tenant}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{tenant.name}</span>
            
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>)
            }
          })}
        </ListboxOptions>
      </div>
    </Listbox>   
        
    </>
      );
}
